import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import cx from "classnames";
import { createPoliza, updatePoliza, statusActions } from "../actions/PolizaActions";
import "../../poliza.scss";
export var polizaGroupButtonsMode;

(function (polizaGroupButtonsMode) {
  polizaGroupButtonsMode["new"] = "new";
  polizaGroupButtonsMode["edit"] = "edit";
  polizaGroupButtonsMode["endorsement"] = "endorsement";
})(polizaGroupButtonsMode || (polizaGroupButtonsMode = {}));

var PolizaGroupButtons = function PolizaGroupButtons(props) {
  var step = props.step,
      changeStep = props.changeStep,
      _props$buttonConfirmD = props.buttonConfirmDisabled,
      buttonConfirmDisabled = _props$buttonConfirmD === void 0 ? true : _props$buttonConfirmD,
      token = props.token,
      poliza = props.poliza,
      mode = props.mode;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isLoading = _React$useState2[0],
      setIsLoading = _React$useState2[1];

  var last_step = 5;

  var callAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(poliza, token) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(mode === polizaGroupButtonsMode["new"])) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", createPoliza(poliza, token));

            case 4:
              return _context.abrupt("return", updatePoliza(poliza, token));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function callAction(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var response, errorMessage, errorEntries, errorList;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              _context2.prev = 1;
              _context2.next = 4;
              return callAction(poliza, token);

            case 4:
              response = _context2.sent;

              if (!((response === null || response === void 0 ? void 0 : response.status) === statusActions.error)) {
                _context2.next = 13;
                break;
              }

              setIsLoading(false); // Formatear mensaje de error más legible

              errorMessage = "Error al guardar la póliza";

              if (response.payload) {
                if (typeof response.payload === 'string') {
                  errorMessage = response.payload;
                } else if (response.payload.message) {
                  errorMessage = response.payload.message;
                } else if (typeof response.payload === 'object') {
                  // Si es un objeto de errores de Rails (ActiveRecord::Errors)
                  errorEntries = Object.entries(response.payload);

                  if (errorEntries.length > 0) {
                    errorList = errorEntries.map(function (_ref3) {
                      var _ref4 = _slicedToArray(_ref3, 2),
                          key = _ref4[0],
                          value = _ref4[1];

                      var fieldName = key.replace(/_/g, ' ').replace(/\b\w/g, function (l) {
                        return l.toUpperCase();
                      });
                      var errorText = Array.isArray(value) ? value.join(', ') : value;
                      return "".concat(fieldName, ": ").concat(errorText);
                    }).join('\n');
                    errorMessage = "Errores de validaci\xF3n:\n".concat(errorList);
                  }
                }
              }

              alert(errorMessage);
              return _context2.abrupt("return");

            case 13:
              if (!((response === null || response === void 0 ? void 0 : response.status) === statusActions.ok)) {
                _context2.next = 15;
                break;
              }

              return _context2.abrupt("return", redirectAction());

            case 15:
              _context2.next = 22;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](1);
              setIsLoading(false);
              console.error(_context2.t0);
              alert("Error inesperado al guardar la póliza. Por favor, intenta de nuevo.");

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 17]]);
    }));

    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var redirectAction = function redirectAction() {
    return window.location.href = "/admin/polizas/";
  };

  var renderButtonConfirmText = function renderButtonConfirmText(text) {
    if (isLoading) return "Cargando...";else return text;
  };

  var handleNextStep = function handleNextStep() {
    if (step === last_step + 1) return;
    if (step === last_step) return changeStep(step + 1);
    return changeStep(step + 1);
  };

  var savePoliza = function savePoliza() {
    return !buttonConfirmDisabled && onSubmit();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "nextButtons"
  }, step !== 1 && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-wizard-modern btn-wizard-view",
    onClick: function onClick() {
      return changeStep(step - 1);
    }
  }, "Anterior"), step < last_step + 1 && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx("btn-wizard-modern btn-wizard-next", step !== 1 && "buttonNext"),
    onClick: function onClick() {
      return handleNextStep();
    }
  }, "Siguiente"), mode == polizaGroupButtonsMode["new"] ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return savePoliza();
    },
    className: "btn-wizard-modern btn-wizard-edit buttonNext",
    disabled: buttonConfirmDisabled || isLoading
  }, renderButtonConfirmText("Crear nueva Póliza")) : mode === polizaGroupButtonsMode.edit ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return savePoliza();
    },
    className: "btn-wizard-modern btn-wizard-edit buttonNext",
    disabled: buttonConfirmDisabled || isLoading
  }, renderButtonConfirmText("Guardar Propuesta")) : mode === polizaGroupButtonsMode.endorsement ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return savePoliza();
    },
    className: "btn-wizard-modern btn-wizard-edit buttonNext",
    disabled: buttonConfirmDisabled || isLoading
  }, renderButtonConfirmText("Guardar Propuesta"))) : null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-wizard-modern btn-wizard-cancel",
    style: {
      marginLeft: "20px"
    },
    onClick: function onClick() {
      return window.location.href = '/admin/polizas';
    }
  }, "Cancelar"));
};

export default PolizaGroupButtons;